import { reportData } from "./reportData.js";
import { reportDataBc } from "./reportDataBc.js";

import api from "../api.ts";
import axios from 'axios';
import _ from "lodash";
import moment from 'moment';
import gql from "graphql-tag";
let printURL;
const initialTime = -30610253143000; // 初始时间1000-01-01 00:00:00
const initialTimeFormat = '1000-01-01';
const getAge = function (birthday, age, createdTime) {
  let showAge;
  if (birthday !== initialTime && birthday !== initialTimeFormat && birthday !== '') {
    showAge = moment().diff(birthday, 'years');
  } else if (Number(age) > -1) {
    showAge = Number(age) + moment().diff(createdTime, 'years');
  }
  return showAge;
};

export const printPDF = {
  data() {
    return {
      reportData: reportData,
      fullscreenLoading: false,
      printPDF_isClose: false,
      printBtn: false
    }
  },
  mounted() {
    const ifrm = this.$refs.iframePDF;
    ifrm.onload = () => {
      setTimeout(() => {
        ifrm.contentWindow.focus();
        ifrm.contentWindow.print();
      }, 100);
    };
  },
  methods: {
    headerChoice(status,hospitalTitle,logoSrc, isBc=false){
      let defaultReportTitle = ''
      if (isBc){
        defaultReportTitle = '皮肤超声检查单'
      }else{
        defaultReportTitle = '皮肤影像检查报告单'
      }
      // 没有医院标题+没有logo
      let NoHosipitalTile={};
      NoHosipitalTile.titleNormal =	{text: defaultReportTitle, alignment: 'center',fontSize: 18,bold: true,margin: [0,15,0,5]};
      NoHosipitalTile.margin = [ 30, 75, 30, 75 ];
      // 有医院标题没有logo
      let hasHosipitalTileNotLogo={};
      hasHosipitalTileNotLogo.titleNormal =	{text: defaultReportTitle, alignment: 'center',fontSize: 18,bold: true,margin: [0,5,0,5]};
      hasHosipitalTileNotLogo.titleHospital =	{text:hospitalTitle, alignment: 'center',fontSize: 18,bold: true,margin: [0,15,0,0]};
      hasHosipitalTileNotLogo.margin = [ 30,110, 30, 75 ];
      // 有医院标题logo
      let hasHosipitalTileAndLogo={};
      hasHosipitalTileAndLogo.titleHospital ={
				id:"reportLogo",
				columns: [
          {image:logoSrc,fit: [900, 85],margin: [0,10,0,0],width:"100%",alignment: 'center'},
					// {id:"reportTitle",text:hospitalTitle,fontSize: 24,bold: true,margin: [0,20,20,0],width:'80%', alignment: 'center'},
					
        ],
        alignment: 'center'
      };
      hasHosipitalTileAndLogo.titleNormal =	{text: defaultReportTitle, alignment: 'center',fontSize: 24,bold: true,margin: [0,5,0,0]};
      // hasHosipitalTileAndLogo.titleHospital ={
			// 	id:"reportLogo",
			// 	columns: [
      //     {image:logoSrc,fit: [100, 100],alignment: 'right',margin: [0,10,10,10]},
			// 		{id:"reportTitle",text:[
			// 			{text: hospitalTitle,  width:'100%'},
			// 			// {text: "\n"+'皮肤影像检查报告单',  width:'100%'},
			// 		], alignment: 'center',fontSize: 24,bold: true,margin: [30,28,0,0],width:'75%'},
					
      //   ],
      //   alignment: 'center'
			// };
      hasHosipitalTileAndLogo.margin = [ 30, 165, 30, 75 ];
      if(status == 3){
        return hasHosipitalTileAndLogo
      }else if(status == 2){
        return hasHosipitalTileNotLogo

      }else{
        return NoHosipitalTile
      }

    },
    async postInfo() {
      try {
        await this.showimgData();
        this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        
        if (this.printreport_data2.review_doctor==""){
          this.$alert("检查医生信息为空，请输入！");
        }
        
        // console.log('this.printreport_images.bc.underMirror：', this.printreport_images.bc.underMirror)
        // console.log('this.printreport_images.ct.underMirror：', this.printreport_images.ct.underMirror)
        // console.log('this.printreport_images.skin.underMirror：', this.printreport_images.skin.underMirror)
        
        let FinalRepoterData = {};

        // ===============Start of 超声报告单独打印，数据模板来自reportDataBc.js,只打印超声所见，不打印皮肤镜、CT、大体图
        // 重要提示：只要“超声所见”内容不为空或者超声选中的报告图片>0，即认为是超声报告，不管是在皮肤镜标签、或者其他标签下。暂时没有用其他变量作为判断依据。
        if (this.printreport_images.bc.underMirror ||  this.printreport_images.bc.imgs.length>0 ){
          // console.log('this.printreport_images.bc.underMirror=true')
          let NewRepoterData = _.cloneDeep(reportDataBc);
          // 修改页眉
          // 获取用户信息
            let reportTitle = await this.$apollo.query({
              query: gql`{
                  me{
                      id,
                      report_title,
                      hospital_logo,
                      print_type
                  }
              }`,
              fetchPolicy: "no-cache"
          });
          this.printreport_title = reportTitle.data.me.report_title;
          let logo =reportTitle.data.me.hospital_logo;
          
          // 报告头： 根据用户是否自定义医院名和医院LOGO，进行信息装配
          if(_.isEmpty(logo)){
            if(_.isEmpty( this.printreport_title)){
              let titleData = this.headerChoice(1, '', '', true);
              NewRepoterData.header.unshift(titleData.titleNormal);
              NewRepoterData.pageMargins=titleData.margin;
            }else{
              let titleData = this.headerChoice(2,reportTitle.data.me.report_title, '', true);
              NewRepoterData.header.unshift(titleData.titleNormal);
              NewRepoterData.header.unshift(titleData.titleHospital);
              NewRepoterData.pageMargins=titleData.margin;
            }
          }else{
            let titleData = this.headerChoice(3,reportTitle.data.me.report_title,'/doctor_images/'+logo, true);
            NewRepoterData.header.unshift(titleData.titleNormal);
            NewRepoterData.header.unshift(titleData.titleHospital);
            NewRepoterData.pageMargins=titleData.margin;
          }
          let itemHeader = NewRepoterData.header.find((e) => {
            return e.id == "header";
          });

          // 页眉：   删除了报告头部的检查编号和检查单位，by steven
          // 报告页眉：检查编号    {text: '检查编号：', fontSize: 12, bold: true}
          // itemHeader.columns[0].text.push(this.printreport_data2.id_in_hospital) ;          
          // 报告页眉：检查单位
          //itemHeader.columns[1].text.push(this.printreport_data2.unit);
  
          // 组装页脚信息
          // 页脚只显示检查医生，且检查医生不是直接获取当前登录用户姓名，而是在左下部分“检查信息”内输入，也即printreport_data2.review_doctor。
          // {
          //   text:[{text: '检查医生：',  bold: true},'${this.printreport_realname}'],
          //   style:['patientsInfo','titleMargin']
          // },
          // {
          //   text: [{text: '审核医生：',  bold: true},'${this.printreport_data2.review_doctor}'],
          //   style:['patientsInfo','titleMargin']
          // },
          NewRepoterData.footer.body = `return [
          { canvas: [ { type: 'line', x1: 30, y1: 0, x2: 570, y2: 0,lineWidth:0.5 } ] },
          {
            columns: [
              {
                text: [{text: '检查医生：',  bold: true},'${this.printreport_data2.review_doctor}'],
                style: ['patientsInfo','titleMargin']
              },
              {
                text: [{text: '报告日期：',  bold: true},'${this.printreport_images.time}'],
                style: ['patientsInfo','titleMargin'],
                width: '30%'
              },
              
            ],
            margin: [30,0,30,0]
          },
          {text:"（本报告单内容仅供参考，如有疑问请与检查医生联系）", alignment: 'left',fontSize: 8,margin: [30,5,30,0]}
          ];`


          // 修改content
          let itemPatientsName = NewRepoterData.content.find((e) => {
            return e.id == "patientsName";
          });
          // 组装患者姓名、性别、年龄、编号
          const nowDate = moment();
          const birthDate = moment(this.printreport_data.birthday);
          const age = getAge(this.printreport_data.birthday, this.printreport_data.age, this.printreport_data.created_time);
          itemPatientsName.columns[0].text.push(this.printreport_data.name);
          itemPatientsName.columns[1].text.push(this.printreport_data.gender);
          itemPatientsName.columns[2].text.push(age);
          itemPatientsName.columns[3].text.push(this.printreport_data.id_in_hospital ? this.printreport_data.id_in_hospital : this.printreport_data.id);
          // 组装申请医生和申请单位
          let itemPatientsDoctor = NewRepoterData.content.find((e) => {
            return e.id == "patientsDoctor";
          });
          itemPatientsDoctor.columns[0].text.push(this.printreport_data2.applicant);
          itemPatientsDoctor.columns[1].text.push(this.printreport_data2.applicant_unit);
          // itemPatientsDoctor.columns[2].text.push(this.printreport_images.time);
          // 组装临床诊断
          let itemPatientsClinical = NewRepoterData.content.find((e) => {
            return e.id == "patientsClinical";
          });
          itemPatientsClinical.columns[1].text += this.printreport_data2.initial_conclusion;

          // 3.一般情况 ， 根据用户需要，设置 不输出该部分信息
          // this.replaceHostory("complaint", this.printreport_data2.complaint, NewRepoterData);
          // this.replaceHostory("disease_history_before", this.printreport_data2.disease_history_before, NewRepoterData);
          // this.replaceHostory("disease_history_present", this.printreport_data2.disease_history_present, NewRepoterData);
          // this.replaceHostory("lab", this.printreport_data2.lab, NewRepoterData);
          // this.replaceHostory("disease_history_family", this.printreport_data2.disease_history_family, NewRepoterData);

          // 4.影像诊断
          // this.replaceHostory("skin", this.printreport_images.skin.underMirror, NewRepoterData);
          // this.replaceHostory("ct", this.printreport_images.ct.underMirror, NewRepoterData);
          this.replaceHostory("bc", this.printreport_images.bc.underMirror, NewRepoterData);
          // this.replaceHostory("bl", this.printreport_images.bl.underMirror, NewRepoterData);
          // this.replaceHostory("general", this.printreport_images.general.underMirror, NewRepoterData);
          
          // 5.图片
          let NewshowImgArr1 = _.clone(this.printreport_showImgArr);
          let NewshowImgArr2 = _.sortBy(NewshowImgArr1,item=>item.print_time)
          let lastObj = _.last(NewshowImgArr2)
          let NewshowImgArr = _.filter(NewshowImgArr2, item=>item.print_time ===lastObj.print_time );
          NewshowImgArr = NewshowImgArr.map(e => {
            e.src = e.src.split("?")[0];
            e.src = e.src.replace(api.server, "")
            return e;
          })
          const index = NewRepoterData.content.findIndex((e) => {
            return e.id == "aboveImage";
          });
          // console.log(NewshowImgArr[0].src.replace("thumbnails/", ""))
          if (NewshowImgArr.length === 1) {
            NewRepoterData.content.splice(index + 1, 0, {
              image: NewshowImgArr[0].src.replace("thumbnails/", ""),
              image: NewshowImgArr[0].src,
              fit: [400, 250],
              alignment: 'center'
            },
              {
                text: NewshowImgArr[0].position.overviewPosition + "-" + NewshowImgArr[0].position.detailPosition + "(" + NewshowImgArr[0].type + ")",
                alignment: 'center',
                style: ['patientsInfo', 'titleMargin']
              });
          } else if(NewshowImgArr.length === 2){
            NewRepoterData.content.splice(index + 1, 0, {
              columns: [
                {
                  // image: NewshowImgArr[i].src.replace("thumbnails/", ""),
                  image: NewshowImgArr[0].src,
                  fit: [200, 200],
                  alignment: 'center',
                },
                {
                  // image: NewshowImgArr[i + 1].src.replace("thumbnails/", ""),
                  image: NewshowImgArr[1].src,
                  fit: [200, 200],
                  alignment: 'center'
                },
              ]
            },
            {
              columns: [
                {
                  text: NewshowImgArr[0].position.overviewPosition + "-" + NewshowImgArr[0].position.detailPosition + "(" + NewshowImgArr[0].type + ")",
                  alignment: 'center',
                  style: ['patientsInfo', 'titleMargin']
                },
                {
                  text: NewshowImgArr[1].position.overviewPosition + "-" + NewshowImgArr[1].position.detailPosition + "(" + NewshowImgArr[1].type + ")",
                  alignment: 'center',
                  style: ['patientsInfo', 'titleMargin']
                }
              ]
            });
          } else if(NewshowImgArr.length === 3){
            NewRepoterData.content.splice(index + 1, 0, {
              columns: [
                {
                  // image: NewshowImgArr[i].src.replace("thumbnails/", ""),
                  image: NewshowImgArr[0].src,
                  fit: [160, 160],
                  alignment: 'center',
                },
                {
                  // image: NewshowImgArr[i + 1].src.replace("thumbnails/", ""),
                  image: NewshowImgArr[1].src,
                  fit: [160, 160],
                  alignment: 'center'
                },
                {
                  // image: NewshowImgArr[i + 1].src.replace("thumbnails/", ""),
                  image: NewshowImgArr[2].src,
                  fit: [160, 160],
                  alignment: 'center'
                },
              ]
            },
            {
              columns: [
                {
                  text: NewshowImgArr[0].position.overviewPosition + "-" + NewshowImgArr[0].position.detailPosition + "(" + NewshowImgArr[0].type + ")",
                  alignment: 'center',
                  style: ['patientsInfo', 'titleMargin']
                },
                {
                  text: NewshowImgArr[1].position.overviewPosition + "-" + NewshowImgArr[1].position.detailPosition + "(" + NewshowImgArr[1].type + ")",
                  alignment: 'center',
                  style: ['patientsInfo', 'titleMargin']
                },
                {
                  text: NewshowImgArr[2].position.overviewPosition + "-" + NewshowImgArr[2].position.detailPosition + "(" + NewshowImgArr[2].type + ")",
                  alignment: 'center',
                  style: ['patientsInfo', 'titleMargin']
                }
              ]
            });
          } else if(NewshowImgArr.length === 4){
            // 2 image in a row, 2 row
            for (let i = 0; i < NewshowImgArr.length; i += 2) {
              NewRepoterData.content.splice(index + 1 + i, 0, {
                columns: [
                  {
                    // image: NewshowImgArr[i].src.replace("thumbnails/", ""),
                    image: NewshowImgArr[i].src,
                    fit: [200, 200],
                    alignment: 'center',
                  },
                  {
                    // image: NewshowImgArr[i + 1].src.replace("thumbnails/", ""),
                    image: NewshowImgArr[i + 1].src,
                    fit: [200, 200],
                    alignment: 'center'
                  },
                ]
              },
                {
                  columns: [
                    {
                      text: NewshowImgArr[i].position.overviewPosition + "-" + NewshowImgArr[i].position.detailPosition + "(" + NewshowImgArr[i].type + ")",
                      alignment: 'center',
                      style: ['patientsInfo', 'titleMargin']
                    },
                    {
                      text: NewshowImgArr[i + 1].position.overviewPosition + "-" + NewshowImgArr[i + 1].position.detailPosition + "(" + NewshowImgArr[i + 1].type + ")",
                      alignment: 'center',
                      style: ['patientsInfo', 'titleMargin']
                    }
                  ]
                });
            }

          } else {
            // 判断是奇数还是偶数
            // if(NewshowImgArr.length>0){}
            // 如果是一排三张图
            let isThree = true;
            if(reportTitle.data.me.print_type == 2){
               isThree =true;
            }else{
              isThree =false
            }
  
            isThree = reportTitle.data.me.print_type == 2;
            if(isThree){
              if (NewshowImgArr.length % 3 === 0) {
  
                for (let i = 0; i < NewshowImgArr.length; i += 3) {
                  let newIndex = 0
                  if(i==0){
                    newIndex = 0
                  }else{
                    newIndex = 2
                  }
                  NewRepoterData.content.splice(index + 1 + newIndex, 0, {
                    columns: [
                      {
                        // image: NewshowImgArr[i].src.replace("thumbnails/", ""),
                        image: NewshowImgArr[i].src,
                        fit: [160, 160],
                        alignment: 'center',
                      },
                      {
                        // image: NewshowImgArr[i + 1].src.replace("thumbnails/", ""),
                        image: NewshowImgArr[i + 1].src,
                        fit: [160, 160],
                        alignment: 'center'
                      },
                      {
                        // image: NewshowImgArr[i + 1].src.replace("thumbnails/", ""),
                        image: NewshowImgArr[i + 2].src,
                        fit: [160, 160],
                        alignment: 'center'
                      },
                    ]
                  },
                    {
                      columns: [
                        {
                          text: NewshowImgArr[i].position.overviewPosition + "-" + NewshowImgArr[i].position.detailPosition + "(" + NewshowImgArr[i].type + ")",
                          alignment: 'center',
                          style: ['patientsInfo', 'titleMargin']
                        },
                        {
                          text: NewshowImgArr[i + 1].position.overviewPosition + "-" + NewshowImgArr[i + 1].position.detailPosition + "(" + NewshowImgArr[i + 1].type + ")",
                          alignment: 'center',
                          style: ['patientsInfo', 'titleMargin']
                        },
                        {
                          text: NewshowImgArr[i + 2].position.overviewPosition + "-" + NewshowImgArr[i + 2].position.detailPosition + "(" + NewshowImgArr[i + 2].type + ")",
                          alignment: 'center',
                          style: ['patientsInfo', 'titleMargin']
                        }
                      ]
                    });
                }
              } else {
                if(NewshowImgArr.length>3){
                  for (let i = 0; i < 2; i += 2) {
                    //console.log(index + 1 + i)
                    NewRepoterData.content.splice(index + 1 + i, 0, {
                      columns: [
                        {
                          image: NewshowImgArr[i].src,
                          fit: [160, 160],
                          alignment: 'center',
                        },
                        {
                          image: NewshowImgArr[i + 1].src,
                          fit: [160, 160],
                          alignment: 'center'
                        },
                        {
                          image: NewshowImgArr[i + 2].src,
                          fit: [160, 160],
                          alignment: 'center'
                        },
                      ]
                    },
                      {
                        columns: [
                          {
                            text: NewshowImgArr[i].position.overviewPosition + "-" + NewshowImgArr[i].position.detailPosition + "(" + NewshowImgArr[i].type + ")",
                            alignment: 'center',
                            style: ['patientsInfo', 'titleMargin']
                          },
                          {
                            text: NewshowImgArr[i + 1].position.overviewPosition + "-" + NewshowImgArr[i + 1].position.detailPosition + "(" + NewshowImgArr[i + 1].type + ")",
                            alignment: 'center',
                            style: ['patientsInfo', 'titleMargin']
                          },
                          {
                            text: NewshowImgArr[i + 2].position.overviewPosition + "-" + NewshowImgArr[i + 2].position.detailPosition + "(" + NewshowImgArr[i + 2].type + ")",
                            alignment: 'center',
                            style: ['patientsInfo', 'titleMargin']
                          }
                        ]
                      });
                  };
                }
  
                // 最后一个单数
                //console.log(index + NewshowImgArr.length)
                let imgA = '';
                let imgB = {};
                let TitleA  = '';
                let TitleB  = '';
                let nums = 0;
                //console.log(NewshowImgArr)
                if(NewshowImgArr.length==5 || NewshowImgArr.length==2){
                   imgA = NewshowImgArr[NewshowImgArr.length - 2].src;
                  //  imgB = NewshowImgArr[NewshowImgArr.length - 1].src;
                   imgB = {
                    image:NewshowImgArr[NewshowImgArr.length - 1].src,
                    fit: [160, 160],
                    alignment: 'center',
                  }
                   TitleA = NewshowImgArr[NewshowImgArr.length - 2].position.overviewPosition + "-" + NewshowImgArr[NewshowImgArr.length - 2].position.detailPosition + "(" + NewshowImgArr[NewshowImgArr.length - 2].type + ")"
                   TitleB = NewshowImgArr[NewshowImgArr.length - 1].position.overviewPosition + "-" + NewshowImgArr[NewshowImgArr.length - 1].position.detailPosition + "(" + NewshowImgArr[NewshowImgArr.length - 1].type + ")"
                  if(NewshowImgArr.length==5){
                   nums = 2
                    
                  }else{
                   nums = 1
  
                  }
                }else{
                  imgB = {
                    text:'' ,
                    fit: [160, 160],
                    alignment: 'center',
                  }
                  imgA = NewshowImgArr[NewshowImgArr.length - 1].src;
                  TitleB = ""
                  TitleA = NewshowImgArr[NewshowImgArr.length - 1].position.overviewPosition + "-" + NewshowImgArr[NewshowImgArr.length - 1].position.detailPosition + "(" + NewshowImgArr[NewshowImgArr.length - 1].type + ")"
                  nums = 1
                }
                NewRepoterData.content.splice(index + NewshowImgArr.length-nums, 0, {
                  columns: [
                    {
                      image:imgA ,
                      fit: [160, 160],
                      alignment: 'center',
                    },
                    imgB,
                    // {
                    //   text: '',
                    //   fit: [160, 160],
                    //   alignment: 'center'
                    // },
                  ]
                },
                  {
                    columns: [
                      {
                        text: TitleA,
                        alignment: 'center',
                        style: ['patientsInfo', 'titleMargin']
                      },
                      {
                        text: TitleB,
                        alignment: 'center',
                        style: ['patientsInfo', 'titleMargin']
                      },
                      // {
                      //   text: '',
                      //   alignment: 'center',
                      //   style: ['patientsInfo', 'titleMargin']
                      // }
                    ]
                  });
              }
            }else{
  
            if (NewshowImgArr.length % 2 === 0) {
  
              for (let i = 0; i < NewshowImgArr.length; i += 2) {
                NewRepoterData.content.splice(index + 1 + i, 0, {
                  columns: [
                    {
                      // image: NewshowImgArr[i].src.replace("thumbnails/", ""),
                      image: NewshowImgArr[i].src,
                      fit: [200, 200],
                      alignment: 'center',
                    },
                    {
                      // image: NewshowImgArr[i + 1].src.replace("thumbnails/", ""),
                      image: NewshowImgArr[i + 1].src,
                      fit: [200, 200],
                      alignment: 'center'
                    },
                  ]
                },
                  {
                    columns: [
                      {
                        text: NewshowImgArr[i].position.overviewPosition + "-" + NewshowImgArr[i].position.detailPosition + "(" + NewshowImgArr[i].type + ")",
                        alignment: 'center',
                        style: ['patientsInfo', 'titleMargin']
                      },
                      {
                        text: NewshowImgArr[i + 1].position.overviewPosition + "-" + NewshowImgArr[i + 1].position.detailPosition + "(" + NewshowImgArr[i + 1].type + ")",
                        alignment: 'center',
                        style: ['patientsInfo', 'titleMargin']
                      }
                    ]
                  });
              }
            } else {
  
              for (let i = 0; i < NewshowImgArr.length - 1; i += 2) {
                NewRepoterData.content.splice(index + 1 + i, 0, {
                  columns: [
                    {
                      // image: NewshowImgArr[i].src.replace("thumbnails/", ""),
                      image: NewshowImgArr[i].src,
                      fit: [200, 200],
                      alignment: 'center',
                    },
                    {
                      // image: NewshowImgArr[i + 1].src.replace("thumbnails/", ""),
                      image: NewshowImgArr[i + 1].src,
                      fit: [200, 200],
                      alignment: 'center'
                    },
                  ]
                },
                  {
                    columns: [
                      {
                        text: NewshowImgArr[i].position.overviewPosition + "-" + NewshowImgArr[i].position.detailPosition + "(" + NewshowImgArr[i].type + ")",
                        alignment: 'center',
                        style: ['patientsInfo', 'titleMargin']
                      },
                      {
                        text: NewshowImgArr[i + 1].position.overviewPosition + "-" + NewshowImgArr[i + 1].position.detailPosition + "(" + NewshowImgArr[i + 1].type + ")",
                        alignment: 'center',
                        style: ['patientsInfo', 'titleMargin']
                      }
                    ]
                  });
              };
              // 最后一个单数
              NewRepoterData.content.splice(index + NewshowImgArr.length, 0, {
                columns: [
                  {
                    // image: NewshowImgArr[NewshowImgArr.length - 1].src.replace("thumbnails/", ""),
                    image: NewshowImgArr[NewshowImgArr.length - 1].src,
                    fit: [200, 200],
                    alignment: 'center',
                  },
                  // {
                  //   text: '',
                  //   fit: [200, 200],
                  //   alignment: 'center'
                  // },
                ]
              },
                {
                  columns: [
                    {
                      text: NewshowImgArr[NewshowImgArr.length - 1].position.overviewPosition + "-" + NewshowImgArr[NewshowImgArr.length - 1].position.detailPosition + "(" + NewshowImgArr[NewshowImgArr.length - 1].type + ")",
                      alignment: 'center',
                      style: ['patientsInfo', 'titleMargin']
                    },
                    // {
                    //   text: '',
                    //   alignment: 'center',
                    //   style: ['patientsInfo', 'titleMargin']
                    // }
                  ]
                });
            }
          }
  
          }
          // }
          // 6.影像诊断 diagnoseResult
          // let itemDiagnoseResult = NewRepoterData.content.find((e) => {
          //   return e.id == "diagnoseResult";
          // });
          // itemDiagnoseResult.columns[1].text += this.printreport_images.diagnoseResult;

          // 7.建议
          // let itemAdvise = NewRepoterData.content.find((e) => {
          //   return e.id == "advise";
          // });
          // itemAdvise.columns[1].text += this.printreport_advise;

          // 8.影像诊断
          if(!_.isEmpty(this.printreport_images.diagnoseResult)){
  
            const index2 = NewRepoterData.content.findIndex((e) => {
              return e.id == "diagnoseResult";
            });
            NewRepoterData.content.splice(index2 + 1, 0, {
              id:"diagnoseResult2",
              columns: [
                {
                  text: [{text: '考虑：',  bold: true}],
                  style:'patientsInfo'
                },
                {
                  text: this.printreport_images.diagnoseResult,
                  width:'480'
                },
              ],
              style:['patientsInfo','titleMargin'],
              width:'480'
            })
          }

          //console.log('B超报告组装完毕，NewRepoterData:',NewRepoterData)
          FinalRepoterData = NewRepoterData
        // ============== END of 超声报告单独打印 ============================
        // ============== Start of 综合报告打印 ============================
        }else{
          //console.log('开始综合报告组装...');
          let NewRepoterData = _.cloneDeep(reportData);
          // 修改页眉
            let reportTitle = await this.$apollo.query({
              query: gql`{
                  me{
                      id,
                      report_title,
                      hospital_logo,
                      print_type
                  }
              }`,
              fetchPolicy: "no-cache"
          });
          this.printreport_title = reportTitle.data.me.report_title;
          let logo =reportTitle.data.me.hospital_logo;
          if(_.isEmpty(logo)){
            if(_.isEmpty( this.printreport_title)){
              let titleData = this.headerChoice(1);
              NewRepoterData.header.unshift(titleData.titleNormal);
              NewRepoterData.pageMargins=titleData.margin;
            }else{
              let titleData = this.headerChoice(2,reportTitle.data.me.report_title);
              NewRepoterData.header.unshift(titleData.titleNormal);
              NewRepoterData.header.unshift(titleData.titleHospital);
              NewRepoterData.pageMargins=titleData.margin;
            }
          }else{
            let titleData = this.headerChoice(3,reportTitle.data.me.report_title,'/doctor_images/'+logo);
            NewRepoterData.header.unshift(titleData.titleNormal);
            NewRepoterData.header.unshift(titleData.titleHospital);
            NewRepoterData.pageMargins=titleData.margin;
          }
          let itemHeader = NewRepoterData.header.find((e) => {
            return e.id == "header";
          });
          
          // 修改，by steven
          // 报告头部：检查编号    {text: '检查编号：', fontSize: 12, bold: true}
          itemHeader.columns[0].text.push(this.printreport_data2.id_in_hospital) ;          
          // 报告头部：检查单位
          //itemHeader.columns[1].text.push(this.printreport_data2.unit);
  
          // 修改页脚，去掉审核医生（下面8行原本在return []内）
          // 页脚只显示检查医生，且检查医生不是直接获取当前登录用户姓名，而是在左下部分“检查信息”内输入，也即printreport_data2.review_doctor。
          // {
          //   text:[{text: '检查医生：',  bold: true},'${this.printreport_realname}'],
          //   style:['patientsInfo','titleMargin']
          // },
          // {
          //     text: [{text: '审核医生：',  bold: true},'${this.printreport_data2.review_doctor}'],
          //     style:['patientsInfo','titleMargin']
          // },
          NewRepoterData.footer.body = `return [
          { canvas: [ { type: 'line', x1: 30, y1: 0, x2: 570, y2: 0,lineWidth:0.5 } ] },
          {
            columns: [
              {
                text: [{text: '检查医生：',  bold: true},'${this.printreport_data2.review_doctor}'],
                style:['patientsInfo','titleMargin']
              },
              {
                text: [{text: '报告日期：',  bold: true},'${this.printreport_images.time}'],
                style:['patientsInfo','titleMargin'],
                width:'30%'
              },
              {
                text: [{text: '页码：',  bold: true},currentPage.toString() + '/' + pageCount],
                style:['patientsInfo','titleMargin'],
                alignment: 'right'
              },
            ],
            margin: [30,0,30,0]
          },
          {text:"（本报告单内容仅供参考，如有疑问请与检查医生联系）", alignment: 'left',fontSize: 8,margin: [30,5,30,0]}
          ];`
         
          // 修改content
          let itemPatientsName = NewRepoterData.content.find((e) => {
            return e.id == "patientsName";
          });
          // 组装患者姓名、性别、年龄、ID
          const nowDate = moment();
          const birthDate = moment(this.printreport_data.birthday);
          const age = getAge(this.printreport_data.birthday, this.printreport_data.age, this.printreport_data.created_time);
          itemPatientsName.columns[0].text.push(this.printreport_data.name);
          itemPatientsName.columns[1].text.push(this.printreport_data.gender);
          itemPatientsName.columns[2].text.push(age);
          itemPatientsName.columns[3].text.push(this.printreport_data.id_in_hospital ? this.printreport_data.id_in_hospital : this.printreport_data.id);
          
          // 组装申请医生、申请单位、申请时间
          let itemPatientsDoctor = NewRepoterData.content.find((e) => {
            return e.id == "patientsDoctor";
          });
          itemPatientsDoctor.columns[0].text.push(this.printreport_data2.applicant);
          itemPatientsDoctor.columns[1].text.push(this.printreport_data2.applicant_unit);
          itemPatientsDoctor.columns[2].text.push(this.printreport_images.time);

          // 组装临床诊断
          let itemPatientsClinical = NewRepoterData.content.find((e) => {
            return e.id == "patientsClinical";
          });
          itemPatientsClinical.columns[1].text += this.printreport_data2.initial_conclusion;
          
          // 3.一般情况
          this.replaceHostory("complaint", this.printreport_data2.complaint, NewRepoterData);
          this.replaceHostory("disease_history_before", this.printreport_data2.disease_history_before, NewRepoterData);
          this.replaceHostory("disease_history_present", this.printreport_data2.disease_history_present, NewRepoterData);
          this.replaceHostory("lab", this.printreport_data2.lab, NewRepoterData);
          this.replaceHostory("disease_history_family", this.printreport_data2.disease_history_family, NewRepoterData);
          
          // 4.所见， 全部模态的镜下所见均会在报告中显示
          this.replaceHostory("skin", this.printreport_images.skin.underMirror, NewRepoterData);
          this.replaceHostory("ct", this.printreport_images.ct.underMirror, NewRepoterData);
          this.replaceHostory("bc", this.printreport_images.bc.underMirror, NewRepoterData);
          this.replaceHostory("bl", this.printreport_images.bl.underMirror, NewRepoterData);
          this.replaceHostory("general", this.printreport_images.general.underMirror, NewRepoterData);
          
          // 5.图片
          let NewshowImgArr1 = _.clone(this.printreport_showImgArr);
          let NewshowImgArr2 = _.sortBy(NewshowImgArr1,item=>item.print_time)
          let lastObj = _.last(NewshowImgArr2)
          let NewshowImgArr = _.filter(NewshowImgArr2, item=>item.print_time ===lastObj.print_time );
          NewshowImgArr = NewshowImgArr.map(e => {
            e.src = e.src.split("?")[0];
            e.src = e.src.replace(api.server, "")
            return e;
          })
          const index = NewRepoterData.content.findIndex((e) => {
            return e.id == "aboveImage";
          });
          // console.log(NewshowImgArr[0].src.replace("thumbnails/", ""))
          // console.log("Print report, NewshowImgArr.length:",NewshowImgArr.length, ",index:",index);
          if (NewshowImgArr.length === 1) {
            NewRepoterData.content.splice(index + 1, 0, {
              image: NewshowImgArr[0].src.replace("thumbnails/", ""),
              image: NewshowImgArr[0].src,
              fit: [400, 250],
              alignment: 'center'
            },
              {
                text: NewshowImgArr[0].position.overviewPosition + "-" + NewshowImgArr[0].position.detailPosition + "(" + NewshowImgArr[0].type + ")",
                alignment: 'center',
                style: ['patientsInfo', 'titleMargin']
              });
          } else if(NewshowImgArr.length === 2){
            NewRepoterData.content.splice(index + 1, 0, {
              columns: [
                {
                  // image: NewshowImgArr[i].src.replace("thumbnails/", ""),
                  image: NewshowImgArr[0].src,
                  fit: [200, 200],
                  alignment: 'center',
                },
                {
                  // image: NewshowImgArr[i + 1].src.replace("thumbnails/", ""),
                  image: NewshowImgArr[1].src,
                  fit: [200, 200],
                  alignment: 'center'
                },
              ]
            },
            {
              columns: [
                {
                  text: NewshowImgArr[0].position.overviewPosition + "-" + NewshowImgArr[0].position.detailPosition + "(" + NewshowImgArr[0].type + ")",
                  alignment: 'center',
                  style: ['patientsInfo', 'titleMargin']
                },
                {
                  text: NewshowImgArr[1].position.overviewPosition + "-" + NewshowImgArr[1].position.detailPosition + "(" + NewshowImgArr[1].type + ")",
                  alignment: 'center',
                  style: ['patientsInfo', 'titleMargin']
                }
              ]
            });
          } else if(NewshowImgArr.length === 3){
            NewRepoterData.content.splice(index + 1, 0, {
              columns: [
                {
                  // image: NewshowImgArr[i].src.replace("thumbnails/", ""),
                  image: NewshowImgArr[0].src,
                  fit: [160, 160],
                  alignment: 'center',
                },
                {
                  // image: NewshowImgArr[i + 1].src.replace("thumbnails/", ""),
                  image: NewshowImgArr[1].src,
                  fit: [160, 160],
                  alignment: 'center'
                },
                {
                  // image: NewshowImgArr[i + 1].src.replace("thumbnails/", ""),
                  image: NewshowImgArr[2].src,
                  fit: [160, 160],
                  alignment: 'center'
                },
              ]
            },
            {
              columns: [
                {
                  text: NewshowImgArr[0].position.overviewPosition + "-" + NewshowImgArr[0].position.detailPosition + "(" + NewshowImgArr[0].type + ")",
                  alignment: 'center',
                  style: ['patientsInfo', 'titleMargin']
                },
                {
                  text: NewshowImgArr[1].position.overviewPosition + "-" + NewshowImgArr[1].position.detailPosition + "(" + NewshowImgArr[1].type + ")",
                  alignment: 'center',
                  style: ['patientsInfo', 'titleMargin']
                },
                {
                  text: NewshowImgArr[2].position.overviewPosition + "-" + NewshowImgArr[2].position.detailPosition + "(" + NewshowImgArr[2].type + ")",
                  alignment: 'center',
                  style: ['patientsInfo', 'titleMargin']
                }
              ]
            });
          } else if(NewshowImgArr.length === 4){
            // 2 image in a row, 2 row
            for (let i = 0; i < NewshowImgArr.length; i += 2) {
              NewRepoterData.content.splice(index + 1 + i, 0, {
                columns: [
                  {
                    // image: NewshowImgArr[i].src.replace("thumbnails/", ""),
                    image: NewshowImgArr[i].src,
                    fit: [200, 200],
                    alignment: 'center',
                  },
                  {
                    // image: NewshowImgArr[i + 1].src.replace("thumbnails/", ""),
                    image: NewshowImgArr[i + 1].src,
                    fit: [200, 200],
                    alignment: 'center'
                  },
                ]
              },
                {
                  columns: [
                    {
                      text: NewshowImgArr[i].position.overviewPosition + "-" + NewshowImgArr[i].position.detailPosition + "(" + NewshowImgArr[i].type + ")",
                      alignment: 'center',
                      style: ['patientsInfo', 'titleMargin']
                    },
                    {
                      text: NewshowImgArr[i + 1].position.overviewPosition + "-" + NewshowImgArr[i + 1].position.detailPosition + "(" + NewshowImgArr[i + 1].type + ")",
                      alignment: 'center',
                      style: ['patientsInfo', 'titleMargin']
                    }
                  ]
                });
            }

          } 
          // else if(NewshowImgArr.length === 5){
          //   // 3 image in first row, 2 in second row
          //   NewRepoterData.content.splice(index + 1, 0, {
          //     columns: [
          //       {
          //         // image: NewshowImgArr[i].src.replace("thumbnails/", ""),
          //         image: NewshowImgArr[0].src,
          //         fit: [160, 160],
          //         alignment: 'center',
          //       },
          //       {
          //         // image: NewshowImgArr[i + 1].src.replace("thumbnails/", ""),
          //         image: NewshowImgArr[1].src,
          //         fit: [160, 160],
          //         alignment: 'center'
          //       },
          //       {
          //         // image: NewshowImgArr[i + 1].src.replace("thumbnails/", ""),
          //         image: NewshowImgArr[2].src,
          //         fit: [160, 160],
          //         alignment: 'center'
          //       },
          //     ]
          //   },
          //   {
          //     columns: [
          //       {
          //         text: NewshowImgArr[0].position.overviewPosition + "-" + NewshowImgArr[0].position.detailPosition + "(" + NewshowImgArr[0].type + ")",
          //         alignment: 'center',
          //         style: ['patientsInfo', 'titleMargin']
          //       },
          //       {
          //         text: NewshowImgArr[1].position.overviewPosition + "-" + NewshowImgArr[1].position.detailPosition + "(" + NewshowImgArr[1].type + ")",
          //         alignment: 'center',
          //         style: ['patientsInfo', 'titleMargin']
          //       },
          //       {
          //         text: NewshowImgArr[2].position.overviewPosition + "-" + NewshowImgArr[2].position.detailPosition + "(" + NewshowImgArr[2].type + ")",
          //         alignment: 'center',
          //         style: ['patientsInfo', 'titleMargin']
          //       }
          //     ]
          //   });

          //   NewRepoterData.content.splice(index + 4, 0, {
          //     columns: [
          //       {
          //         // image: NewshowImgArr[i].src.replace("thumbnails/", ""),
          //         image: NewshowImgArr[3].src,
          //         fit: [160, 160],
          //         alignment: 'center',
          //       },
          //       {
          //         // image: NewshowImgArr[i + 1].src.replace("thumbnails/", ""),
          //         image: NewshowImgArr[4].src,
          //         fit: [160, 160],
          //         alignment: 'center'
          //       },
          //       {
          //         text: '',
          //         fit: [160, 160],
          //         alignment: 'center'
          //       },
          //     ]
          //   },
          //   {
          //     columns: [
          //       {
          //         text: NewshowImgArr[3].position.overviewPosition + "-" + NewshowImgArr[3].position.detailPosition + "(" + NewshowImgArr[3].type + ")",
          //         alignment: 'center',
          //         style: ['patientsInfo', 'titleMargin']
          //       },
          //       {
          //         text: NewshowImgArr[4].position.overviewPosition + "-" + NewshowImgArr[4].position.detailPosition + "(" + NewshowImgArr[4].type + ")",
          //         alignment: 'center',
          //         style: ['patientsInfo', 'titleMargin']
          //       },
          //       {
          //         text: '',
          //         alignment: 'center',
          //         style: ['patientsInfo', 'titleMargin']
          //       }
          //     ]
          //   });

            


          // } 
          else {
            // NewshowImgArr.length >= 5

            // 判断是奇数还是偶数
            // if(NewshowImgArr.length>0){}
            // 如果是一排三张图
            let isThree = true;
            // if(reportTitle.data.me.print_type == 2){
            //    isThree =true;
            // }else{
            //   isThree =false
            // }  
            isThree = reportTitle.data.me.print_type == 2;
            //console.log("Print report, isThree:",isThree);
            // three image in 1 row
            if(isThree){
              if (NewshowImgArr.length % 3 === 0) {
  
                for (let i = 0; i < NewshowImgArr.length; i += 3) {
                  let newIndex = 0
                  if(i==0){
                    newIndex = 0
                  }else{
                    newIndex = 2
                  }
                  NewRepoterData.content.splice(index + 1 + newIndex, 0, {
                    columns: [
                      {
                        // image: NewshowImgArr[i].src.replace("thumbnails/", ""),
                        image: NewshowImgArr[i].src,
                        fit: [160, 160],
                        alignment: 'center',
                      },
                      {
                        // image: NewshowImgArr[i + 1].src.replace("thumbnails/", ""),
                        image: NewshowImgArr[i + 1].src,
                        fit: [160, 160],
                        alignment: 'center'
                      },
                      {
                        // image: NewshowImgArr[i + 1].src.replace("thumbnails/", ""),
                        image: NewshowImgArr[i + 2].src,
                        fit: [160, 160],
                        alignment: 'center'
                      },
                    ]
                  },
                    {
                      columns: [
                        {
                          text: NewshowImgArr[i].position.overviewPosition + "-" + NewshowImgArr[i].position.detailPosition + "(" + NewshowImgArr[i].type + ")",
                          alignment: 'center',
                          style: ['patientsInfo', 'titleMargin']
                        },
                        {
                          text: NewshowImgArr[i + 1].position.overviewPosition + "-" + NewshowImgArr[i + 1].position.detailPosition + "(" + NewshowImgArr[i + 1].type + ")",
                          alignment: 'center',
                          style: ['patientsInfo', 'titleMargin']
                        },
                        {
                          text: NewshowImgArr[i + 2].position.overviewPosition + "-" + NewshowImgArr[i + 2].position.detailPosition + "(" + NewshowImgArr[i + 2].type + ")",
                          alignment: 'center',
                          style: ['patientsInfo', 'titleMargin']
                        }
                      ]
                    });
                }
              } else {
                if(NewshowImgArr.length>3){
                  for (let i = 0; i < 2; i += 2) {
                    //console.log(index + 1 + i)
                    NewRepoterData.content.splice(index + 1 + i, 0, {
                      columns: [
                        {
                          image: NewshowImgArr[i].src,
                          fit: [160, 160],
                          alignment: 'center',
                        },
                        {
                          image: NewshowImgArr[i + 1].src,
                          fit: [160, 160],
                          alignment: 'center'
                        },
                        {
                          image: NewshowImgArr[i + 2].src,
                          fit: [160, 160],
                          alignment: 'center'
                        },
                      ]
                    },
                      {
                        columns: [
                          {
                            text: NewshowImgArr[i].position.overviewPosition + "-" + NewshowImgArr[i].position.detailPosition + "(" + NewshowImgArr[i].type + ")",
                            alignment: 'center',
                            style: ['patientsInfo', 'titleMargin']
                          },
                          {
                            text: NewshowImgArr[i + 1].position.overviewPosition + "-" + NewshowImgArr[i + 1].position.detailPosition + "(" + NewshowImgArr[i + 1].type + ")",
                            alignment: 'center',
                            style: ['patientsInfo', 'titleMargin']
                          },
                          {
                            text: NewshowImgArr[i + 2].position.overviewPosition + "-" + NewshowImgArr[i + 2].position.detailPosition + "(" + NewshowImgArr[i + 2].type + ")",
                            alignment: 'center',
                            style: ['patientsInfo', 'titleMargin']
                          }
                        ]
                      });
                  };
                }
  
                // 最后一个单数
                //console.log(index + NewshowImgArr.length)
                let imgA = '';
                let imgB = {};
                let TitleA  = '';
                let TitleB  = '';
                let nums = 0;
                //console.log(NewshowImgArr)
                if(NewshowImgArr.length==5 || NewshowImgArr.length==2){
                   imgA = NewshowImgArr[NewshowImgArr.length - 2].src;
                  //  imgB = NewshowImgArr[NewshowImgArr.length - 1].src;
                   imgB = {
                    image:NewshowImgArr[NewshowImgArr.length - 1].src,
                    fit: [160, 160],
                    alignment: 'center',
                  }
                   TitleA = NewshowImgArr[NewshowImgArr.length - 2].position.overviewPosition + "-" + NewshowImgArr[NewshowImgArr.length - 2].position.detailPosition + "(" + NewshowImgArr[NewshowImgArr.length - 2].type + ")"
                   TitleB = NewshowImgArr[NewshowImgArr.length - 1].position.overviewPosition + "-" + NewshowImgArr[NewshowImgArr.length - 1].position.detailPosition + "(" + NewshowImgArr[NewshowImgArr.length - 1].type + ")"
                  if(NewshowImgArr.length==5){
                   nums = 2
                    
                  }else{
                   nums = 1
  
                  }
                }else{
                  imgB = {
                    text:'' ,
                    fit: [160, 160],
                    alignment: 'center',
                  }
                  imgA = NewshowImgArr[NewshowImgArr.length - 1].src;
                  TitleB = ""
                  TitleA = NewshowImgArr[NewshowImgArr.length - 1].position.overviewPosition + "-" + NewshowImgArr[NewshowImgArr.length - 1].position.detailPosition + "(" + NewshowImgArr[NewshowImgArr.length - 1].type + ")"
                  nums = 1
                }
                NewRepoterData.content.splice(index + NewshowImgArr.length-nums, 0, {
                  columns: [
                    {
                      image:imgA ,
                      fit: [160, 160],
                      alignment: 'center',
                    },
                    imgB,
                     // 去掉空白占位，使2张图片图片居中（5张图片的情况）
                    // {
                    //   text: '',
                    //   fit: [160, 160],
                    //   alignment: 'center'
                    // },
                  ]
                },
                  {
                    columns: [
                      {
                        text: TitleA,
                        alignment: 'center',
                        style: ['patientsInfo', 'titleMargin']
                      },
                      {
                        text: TitleB,
                        alignment: 'center',
                        style: ['patientsInfo', 'titleMargin']
                      },
                      // {
                      //   text: '',
                      //   alignment: 'center',
                      //   style: ['patientsInfo', 'titleMargin']
                      // }
                    ]
                  });
              }
            // isThree = false  
            }else{  
              // two image in 1 row
              if (NewshowImgArr.length % 2 === 0) {    
                for (let i = 0; i < NewshowImgArr.length; i += 2) {
                  NewRepoterData.content.splice(index + 1 + i, 0, {
                    columns: [
                      {
                        // image: NewshowImgArr[i].src.replace("thumbnails/", ""),
                        image: NewshowImgArr[i].src,
                        fit: [200, 200],
                        alignment: 'center',
                      },
                      {
                        // image: NewshowImgArr[i + 1].src.replace("thumbnails/", ""),
                        image: NewshowImgArr[i + 1].src,
                        fit: [200, 200],
                        alignment: 'center'
                      },
                    ]
                  },
                    {
                      columns: [
                        {
                          text: NewshowImgArr[i].position.overviewPosition + "-" + NewshowImgArr[i].position.detailPosition + "(" + NewshowImgArr[i].type + ")",
                          alignment: 'center',
                          style: ['patientsInfo', 'titleMargin']
                        },
                        {
                          text: NewshowImgArr[i + 1].position.overviewPosition + "-" + NewshowImgArr[i + 1].position.detailPosition + "(" + NewshowImgArr[i + 1].type + ")",
                          alignment: 'center',
                          style: ['patientsInfo', 'titleMargin']
                        }
                      ]
                    });
                }
              // NewshowImgArr.length % 2 != 0
              } else {    
                for (let i = 0; i < NewshowImgArr.length - 1; i += 2) {
                  NewRepoterData.content.splice(index + 1 + i, 0, {
                    columns: [
                      {
                        // image: NewshowImgArr[i].src.replace("thumbnails/", ""),
                        image: NewshowImgArr[i].src,
                        fit: [200, 200],
                        alignment: 'center',
                      },
                      {
                        // image: NewshowImgArr[i + 1].src.replace("thumbnails/", ""),
                        image: NewshowImgArr[i + 1].src,
                        fit: [200, 200],
                        alignment: 'center'
                      },
                    ]
                  },
                    {
                      columns: [
                        {
                          text: NewshowImgArr[i].position.overviewPosition + "-" + NewshowImgArr[i].position.detailPosition + "(" + NewshowImgArr[i].type + ")",
                          alignment: 'center',
                          style: ['patientsInfo', 'titleMargin']
                        },
                        {
                          text: NewshowImgArr[i + 1].position.overviewPosition + "-" + NewshowImgArr[i + 1].position.detailPosition + "(" + NewshowImgArr[i + 1].type + ")",
                          alignment: 'center',
                          style: ['patientsInfo', 'titleMargin']
                        }
                      ]
                    });
                };
                // 最后一个单数
                NewRepoterData.content.splice(index + NewshowImgArr.length, 0, {
                  columns: [
                    {
                      // image: NewshowImgArr[NewshowImgArr.length - 1].src.replace("thumbnails/", ""),
                      image: NewshowImgArr[NewshowImgArr.length - 1].src,
                      fit: [200, 200],
                      alignment: 'center',
                    },
                    // 去掉空白占位，使单一图片居中
                    // {
                    //   text: '',
                    //   fit: [200, 200],
                    //   alignment: 'center'
                    // },
                  ]
                },
                  {
                    columns: [
                      {
                        text: NewshowImgArr[NewshowImgArr.length - 1].position.overviewPosition + "-" + NewshowImgArr[NewshowImgArr.length - 1].position.detailPosition + "(" + NewshowImgArr[NewshowImgArr.length - 1].type + ")",
                        alignment: 'center',
                        style: ['patientsInfo', 'titleMargin']
                      },
                      // {
                      //   text: '',
                      //   alignment: 'center',
                      //   style: ['patientsInfo', 'titleMargin']
                      // }
                    ]
                  });
              }
            }
  
          }
          // }
          // 6.影像诊断 diagnoseResult
          // let itemDiagnoseResult = NewRepoterData.content.find((e) => {
          //   return e.id == "diagnoseResult";
          // });
          // itemDiagnoseResult.columns[1].text += this.printreport_images.diagnoseResult;
          
          // 7.建议
          let itemAdvise = NewRepoterData.content.find((e) => {
            return e.id == "advise";
          });
          itemAdvise.columns[1].text += this.printreport_advise;
          
          // 8.影像诊断
          if(!_.isEmpty(this.printreport_images.diagnoseResult)){
  
            const index2 = NewRepoterData.content.findIndex((e) => {
              return e.id == "diagnoseResult";
            });
            NewRepoterData.content.splice(index2 + 1, 0, {
              id:"diagnoseResult2",
              columns: [
                {
                  text: [{text: '影像诊断：',  bold: true}],
                  style:'patientsInfo'
                },
                {
                  text: this.printreport_images.diagnoseResult,
                  width:'480'
                },
              ],
              style:['patientsInfo','titleMargin'],
              width:'480'
            })
          }
          FinalRepoterData = NewRepoterData
        // ============== END of 综合报告打印
        }


        //=================报告数据及文档格式组装结束==================

        // 提交后台生成PDF文档
        console.log('before post request NewRepoterData');
        let headersData = {};
        // 是否需要生成云胶片，在request headers设置 diagnosisId
        if(this.needGenOnlineReport){
          headersData['diagnosisid'] = this.diagnosisId;
          console.log('Need generate online report.diagnosis id:',this.diagnosisId);
        }
        let response = await axios.request({
          method: 'post',
          url: api.pdfmake,
          responseType: 'arraybuffer',
          //data: NewRepoterData,
          data: FinalRepoterData,
          headers: headersData
        });
        console.log('In print pdf, post request FinalRepoterData:',FinalRepoterData);

        if (this.printreport_isDownLoad) {
          const blob = new Blob([response.data], { type: 'application/pdf' });
          this.openDownloadDialog(blob, `${this.printreport_data.name}-${this.printreport_images.time}.pdf`);
          this.$loading().close();
        } else {
          this.$loading().close();
          this.print(response.data);
        }
      } catch (error) {
        console.log(error)
        this.$loading().close();
        alert("报告转换失败");
      }
    },
    replaceHostory(id, data, NewRepoterData) {
      if (data !== '') {
        (NewRepoterData.content.find((e) => { return e.id == id; })).columns[1].text += data;
      } else {
        const index = NewRepoterData.content.findIndex((e) => {
          return e.id == id;
        });
        NewRepoterData.content.splice(index, 1);
        //   NewRepoterData.content.splice(index,0);
      }
    },
    print(data) {
      const blob = new Blob([data], { type: 'application/pdf' });
      if (printURL) {
        URL.revokeObjectURL(printURL);
      }
      printURL = URL.createObjectURL(blob);
      const ifrm = this.$refs.iframePDF;

      ifrm.src = printURL;

    },
    openDownloadDialog(url, saveName) {
      if (typeof url == 'object' && url instanceof Blob) {
        url = URL.createObjectURL(url); // 创建blob地址
      }
      var aLink = document.createElement('a');
      aLink.href = url;
      aLink.download = saveName || ''; // HTML5新增的属性，指定保存文件名，可以不要后缀，注意，file:///模式下不会生效
      var event;
      if (window.MouseEvent) {
        event = new MouseEvent('click');
        console.log(event)
      } else {
        event = document.createEvent('MouseEvents');
        event.initMouseEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
      }
      aLink.dispatchEvent(event);
    },


  }
}
